// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KZuL","col":"styles_col__1hUZa"};